<template lang="pug">
  include /mixins
  +b.circle-btn.--variant_2.BUTTON(
    @click.prevent='open'
    :disabled='!cart_info.quantity'
  )
    +e.icon
      svg(width='24' height='24' viewbox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
        path(d='M3.25918 9.45953C3.12579 8.83702 3.60034 8.25 4.23699 8.25H19.763C20.3997 8.25 20.8742 8.83702 20.7408 9.45953L18.598 19.4595C18.4992 19.9206 18.0917 20.25 17.6202 20.25H6.37984C5.90831 20.25 5.50084 19.9206 5.40204 19.4595L3.25918 9.45953Z' stroke='#1183F6')
        path(d='M6.06632 8.25048L8.92977 3.75285' stroke='#1183F6' stroke-linecap='round')
        path(d='M17.9337 8.24657L15.0702 3.74895' stroke='#1183F6' stroke-linecap='round')
        path(d='M9.20304 12.9027C9.95565 12.2289 10.6736 11.5164 11.3679 10.7834C11.4382 10.7092 11.5432 10.535 11.6487 10.5001C11.6675 10.4938 11.4846 10.8941 11.4741 10.9164C11.1874 11.5233 10.8666 12.11 10.6055 12.7293C10.1854 13.7258 9.77619 14.7243 9.33107 15.7102C9.25653 15.8753 9.18748 16.0426 9.11575 16.2089C9.11477 16.2112 8.98873 16.4979 9.00082 16.4995C9.10766 16.5137 9.41274 16.2087 9.48093 16.1569C9.85532 15.8726 10.2256 15.5863 10.5794 15.2765C11.5302 14.4439 12.4168 13.5294 13.2811 12.6093C13.286 12.604 13.4916 12.4049 13.4862 12.4517C13.4709 12.5849 13.3531 12.7505 13.2971 12.8652C13.1214 13.2249 12.9359 13.5789 12.7529 13.9349C12.5228 14.3827 12.3181 14.8391 12.1288 15.3054C12.0094 15.5995 11.8515 15.9289 11.784 16.2451C11.7424 16.4398 11.828 16.4262 12.0066 16.3824C12.611 16.2341 13.1885 15.9224 13.7452 15.6553C14.42 15.3315 15.0699 14.9581 15.75 14.6462' stroke='#1183F6' stroke-width='0.9' stroke-linecap='round')
    +e.counter.--variant_1.SPAN {{ cart_info.quantity || 0 }}
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CartPreview',
  props: ['withGetter'],
  data() {
    return {
      link: window.cart_page,
    }
  },
  computed: {
    ...mapState('cart', [
      'cart_info',
    ]),
  },
  created() {
    if (this.withGetter) this.getCartInfo()
  },
  mounted() {
    if (window.is_cart_view && this.withGetter) {
      this.$refs['cart-modal'].openPopup()
    }
  },
  methods: {
    ...mapActions('cart', [
      'getCartInfo',
    ]),
    open() {
      window.location.href = this.link
    },
  },
}
</script>
